import styles from "../styles/App.module.css";
import Box from "@mui/material/Box";
import {Autocomplete, Chip, InputAdornment, TextField} from "@mui/material";
import * as React from "react";
import Button from "@mui/material/Button";
import Drawer from "@mui/material/Drawer";

import filterConfig from "../data/filtersConfig.json";
const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

export default function Filters({applyFilters}) {
    const [filters, setFilters] = React.useState({});
    const [showFilters, setShowFilters] = React.useState(false);

    const handleSearchClick = React.useCallback(() => {
        applyFilters(filters);
        setShowFilters(false);
    }, [applyFilters, filters]);

    const clearFilters = React.useCallback(() => {
        applyFilters({});
        setFilters({});
    }, [applyFilters]);

    const handleSearchInputChange = React.useCallback((e) => {
        setFilters({...filters, [e.target.name]: e.target.value})
        // applyFilters({...filters, [e.target.name]: e.target.value})
    }, [filters]);

    const applyTagFilters = React.useCallback((item) => {
        let tmpFilters = {...filters};
        let idx = -1;
        tmpFilters.Kutiya?.map((x, i) => {
            if (x.id === item.id) { idx = i; }
            return x;
        })
        if (idx > -1) {
            tmpFilters.Kutiya.splice(idx, 1);
        } else {
            tmpFilters.Kutiya = [item];
        }
        setFilters(tmpFilters);
        applyFilters(tmpFilters);
    }, [applyFilters, filters]);

    const isChecked = (item) => {
        let hasValue = false;
        filters.Kutiya?.map((x, i) => {
            if (x.id === item.id) { hasValue = true; }
            return x;
        })
        return hasValue;
    }

    React.useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        let kutiyaId = urlParams.get("kutiya");
        if (!kutiyaId) return;
        try {
            setFilters({Kutiya: [{id: parseInt(kutiyaId)}]});
            applyFilters({Kutiya: [{id: parseInt(kutiyaId)}]});
        } catch (err) {
            console.log("invalid query params")
        }

    }, [applyFilters])

    return (
        <div className={styles.filterContainer}>
            <Box sx={{display: 'flex', alignItems: 'center', justifyContent: "center", flexDirection: 'column'}}>
            <div className={styles.tagsContainer}>
                    <Chip
                        className={styles.filterTag}
                        color="primary"
                        label="All"
                        onClick={() => clearFilters()}
                        variant={filters?.Kutiya?.length ? "outlined" : "filled"}
                    />
                    {filterConfig[0].values.map((item) => (
                        <Chip
                            className={styles.filterTag}
                            color="primary"
                            label={item.label}
                            key={item.id}
                            onClick={() => applyTagFilters(item)}
                            variant={isChecked(item) ? "filled" : "outlined"}
                        />
                    ))}
                </div>
                
                {/* <TextField
                    fullWidth
                    sx={{maxWidth: '400px'}}
                    size="small"
                    label="Type to search . . ."
                    variant="outlined"
                    name="text"
                    onChange={handleSearchInputChange}
                    value={filters.text || ""}
                    slotProps={{
                        input: {
                            endAdornment: <InputAdornment position="end">
                                <Button onClick={handleSearchClick}>Go</Button>
                            </InputAdornment>,
                        },
                    }}
                />
                 */}
                <div
                    style={{
                        // display: "flex",
                        display: "none",
                        justifyContent: Object.keys(filters).length !== 0 ? "space-between": "right",
                        width: "100%",
                        maxWidth: "400px"
                    }}
                >
                    {Object.keys(filters).length !== 0 && (
                        <Button
                            variant="text"
                            color="secondary"
                            size="small"
                            onClick={clearFilters}
                            sx={{color: "grey", fontSize: "0.7rem"}}
                        >
                            Clear ({Object.keys(filters).length} filters applied)
                        </Button>
                    )}
                    <Button
                        variant="text"
                        size="small"
                        onClick={() => setShowFilters(!showFilters)}
                    >
                        Search By Kutiya
                    </Button>
                </div>
            </Box>
            <Drawer
                anchor={ isMobile ? "bottom" : "right" }
                open={showFilters}
                onClose={() => setShowFilters(!showFilters)}
            >
                <Box hidden={!showFilters} sx={{padding: 3, width: 350}}>
                    {filterConfig.map(fc => (
                        <div className={styles.filterItem} key={fc.name}>
                            <Autocomplete 
                                inputmode= "none"
                                options={fc.values}
                                sx={{minWidth: 250}}
                                multiple={fc.type === "multiselect"}
                                value={filters[fc.name] || []}
                                renderInput={(params) =>
                                    <TextField 
                                        {...params}
                                        variant="outlined"
                                        label={fc.name}
                                        placeholder={!filters[fc.name]?.length ? fc.placeholder: ""}
                                    />
                                }
                                onChange={(e, v) => setFilters({...filters, [fc.name]: v})}
                            />
                        </div>
                    ))}
                    <div className={styles.filterItem} style={{display: "flex", justifyContent: "right"}}>
                        <Button onClick={handleSearchClick}>Go</Button>
                    </div>
                </Box>
            </Drawer>
        </div>
    );
}